import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import { CREATE } from "react-admin";
import { isNil, prop, path, map } from "ramda";
import {
  showNotification,
  SaveButton,
  SimpleForm,
  LongTextInput,
  TextInput,
  BooleanInput
} from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import dataProviderFactory from "../dataProvider";
import AttachMoney from "@material-ui/icons/AttachMoney";
import { required } from "ra-core";
import styled from "styled-components";

import { Select, InputLabel, MenuItem } from "@material-ui/core";
import styles from "./dashboard/Styles";

const StyledSelect = styled(Select)`
  width: 256px !important;
`;

const StyledInputLabel = styled(InputLabel)`
  &&& {
    font-size: 16px !important;
  }
`;

const theme = {
  blue: {
    default: "#006faf",
    hover: "#283593"
  },
  pink: {
    default: "#e91e63",
    hover: "#ad1457"
  }
};

const Button = styled.a`
  background-color: ${(props) => theme[props.theme].default};
  color: white;
  padding: 5px 15px;
  border-radius: 5px; 
  outline: 0;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0px 2px 2px lightgray;
  transition: ease background-color 250ms; 
  text-align: center;  
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${(props) => theme[props.theme].hover};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

Button.defaultProps = {
  theme: "blue"
};


class AddSuplementCharge extends Component {
  handleValueChange = element => {
    if ('chargeValue' == element.target.name) { 
      let value = parseFloat(element.target.value, 2) 
      if ( value <= 0) { 
        this.setState({ chargeValue : 0, disabledSave: true });
      }
      else{
        this.setState({ chargeValue: element.target.value, disabledSave: false });
      }
    }  
    if ('invoiceComments' == element.target.name) { 
      if (element.target.value != "" || element.target.value != null) { 
        this.setState({ invoiceComments: element.target.value, disabledSave: false });
      }
    }
    if ('imtComments' == element.target.name) { 
      if (element.target.value != "" || element.target.value != null) { 
        this.setState({ imtComments: element.target.value});
      }
    }
  };

  handleValueChangeBool = element => { 
    if ('generate_invoice' == element.target.name) {
       this.setState({ generate_invoice: element.target.checked });
    } 
  };

  state = { 
    error: false,
    showDialog: false, 
    isOnSubmit: false,
    chargeValue: 0,
    generate_invoice: false,
    invoiceComments: "",
    imtComments: "", 
    disabledSave: true
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleChangeItem = (element, type) => {
    this.setState({ [type]: element.target.value });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    this.setState({ isOnSubmit: true }, () => {
      submit("suplement-send");
    });
  };

  handleSubmit = async () => {
    const { history, rental } = this.props;
    const { booking } = rental
    let chargeValue = this.state.chargeValue
    // if(booking.r_cancel_insurance){
    //   chargeValue =  Number(chargeValue) + Number((chargeValue * 0.075)) 
    // }
    const bodyRequest = {
      data: {
        rental_id: this.props.rental.id,
        chargeValue: parseFloat(chargeValue,2),
        invoiceComments: this.state.invoiceComments, 
        imtComments: this.state.imtComments, 
        generate_invoice: this.state.generate_invoice,
      }
    };
    const dataProvider = await dataProviderFactory("rest");
    dataProvider(CREATE, "rentals/add_suplement", bodyRequest)
      .then(() => {
        this.props.showNotification("Supplement created with success");
        this.setState({ 
          error: false,
          showDialog: false, 
          isOnSubmit: false,
          chargeValue: 0,
          generate_invoice: false,
          invoiceComments: "",
          imtComments: "", 
          disabledSave: true
        });
        if (!isNil(history)) {
          history.history.replace(
            `/${rental.type === 1 ? "tour_due_list" : "rentals_due"
            }?filter=%7B"date_begin"%3A"${Date()}"%7D&page=1&perPage=10&_sort=id&_order=desc`
          );
        } 
      })
      .catch(error => {
        this.props.showNotification(error.message, "error");
      });

      setTimeout(function(){
        window.location.reload(1);
      }, 5000);
  };

  render() {
 
    const { rental } = this.props;

    const { showDialog, isOnSubmit } = this.state;

    return (
      <Fragment>
        <Button onClick={this.handleClick}>
          <AttachMoney style={styles.aligTextButton} cursor="pointer" />
          <span style={styles.aligTextButton}>Add Supplement</span>
        </Button>
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Add Supplement"
        >
          <DialogTitle style={styles.centerText}>
            {`Add Supplement - ${!isNil(rental.client_name)
              ? rental.client_name
              : `${prop("r_first_name", prop("booking", rental))} ${prop(
                "r_last_name",
                prop("booking", rental)
              )} `
              } for ${rental.type === 1
                ? `${rental.tour_name
                  ? rental.tour_name
                  : this.props.rental.booking.tour.tour_name.tour_name_en
                }`
                : "Rental"
              }`}{" "}<br />
            <span>{`Rental ID: ${rental.id}`}</span><br />
            <span>{`Start Date ${rental.date_1} to ${rental.date_2}`}</span>
          </DialogTitle>
          <DialogContent>
            <SimpleForm
              form="suplement-send"
              resource="suplement"
              onSubmit={this.handleSubmit}
              toolbar={null}
              destroyOnUnmount={true}
            >
              {/* charge comentario  */}
              <LongTextInput
                source="invoiceComments" /* invoiceComments */
                label="Comentario de la factura"
                type="text"
                onChange={this.handleValueChange}
                value={this.state.invoiceComments}
                validate={ this.state.generate_invoice ? required() : false}
                //disabled={ this.state.generate_invoice ? false : true}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <LongTextInput
                source="imtComments"
                label="Imt Comments"
                type="text"
                value={this.state.imtComments}
                onChange={this.handleValueChange}
                validate={required()}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <div style={styles.widthFull}>
                <div style={styles.flex}>
                  <div style={styles.leftColB}>
                    <div style={styles.widthFull}>
                      {/* valor a cargar */}
                      <TextInput
                        source="chargeValue"
                        label="Charge Value (Euros)"
                        type="number" style={
                          styles.widthPartial2
                        }
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        min="1"
                        value={this.state.chargeValue}
                        onChange={this.handleValueChange}
                        validate={required()}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                  </div>
                  <div style={styles.rightCol}>
                    <div style={styles.flex}>
                      {/* geenrar factura al guardar suplemento */}  
                      <BooleanInput
                        label="Charge now"
                        source="generate_invoice"
                        onChange={this.handleValueChangeBool}
                        style={styles.flexPadtop}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SimpleForm>
          </DialogContent>
          <DialogActions>
            <SaveButton
              saving={isOnSubmit}
              onClick={this.handleSaveClick}
              disabled={ 
                this.state.disabledSave
              }
            />
            <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
              <IconCancel style={styles.aligTextButton} /> 
              <span style={styles.aligTextButton}> Cancel</span>
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isSubmitting: isSubmitting("suplement-send")(state)
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(AddSuplementCharge);



// WEBPACK FOOTER //
// ./src/components/addSuplementCharge.js